// Slick Carousel
import Glide from "@glidejs/glide";

class CarouselImageFullWidth {
  constructor() {
    // element that will be wrapped
    const carousel = document.querySelector('.carousel-image-full-width');

    if (carousel) {
      const carouselTrack = document.querySelector(
        '.carousel-image-full-width .wp-block-group'
      );
      const carouselSlides = carouselTrack.querySelector(
        '.carousel-image-full-width .wp-block-group .wp-block-gallery'
      );
      const carouselIndividualSlide = carouselTrack.querySelectorAll(
        '.carousel-image-full-width .wp-block-group .wp-block-gallery .wp-block-image'
      );

      // Add Glide classes
      carouselTrack.classList.add("glide__track");
      carouselTrack.dataset.glideEl = "track";
      carouselSlides.classList.add("glide__slides");
      carouselIndividualSlide.forEach((item) => {
        item.classList.add("glide__slide");
      });

      // Tweak styles
      carousel.style.overflow = "hidden";
      carouselSlides.style.flexWrap = "nowrap";

      // Mount carousel
      var threeSlideGlide = new Glide(".carousel-image-full-width", {
        type: "carousel",
        perView: 8,
        breakpoints: {
          1600: { perView: 7 },
          1400: { perView: 6 },
          1200: { perView: 5 },
          1000: { perView: 4 },
          700: { perView: 3 },
        },
        autoplay: 3000,
      }).mount();
    }
  }
}

export default CarouselImageFullWidth;
